"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
  }
  result["default"] = mod;
  return result;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_i18next_1 = require("react-i18next");

var react_1 = __importStar(require("react"));

var react_redux_1 = require("react-redux");

var react_web_components_1 = require("@nimles/react-web-components");

var react_2 = require("@emotion/react");

var react_redux_2 = require("@nimles/react-redux");

var react_fontawesome_1 = require("@fortawesome/react-fontawesome");

var free_solid_svg_icons_1 = require("@fortawesome/free-solid-svg-icons");

var Link_1 = require("./Link");

var styled_1 = __importDefault(require("@emotion/styled"));

var User = styled_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  justify-content: center;\n"], ["\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  justify-content: center;\n"])));

exports.UserMenu = function () {
  var dispatch = react_redux_1.useDispatch();

  var _a = react_1.useState(false);

  var t = react_i18next_1.useTranslation().t;
  var user = react_redux_1.useSelector(function (_a) {
    var currentUser = _a.currentUser;
    return currentUser;
  }).user;
  var theme = react_2.useTheme();
  var size = react_web_components_1.useWindowSize();

  var handleSignOut = function handleSignOut() {
    dispatch(react_redux_2.signOutUser());
  };

  var items = [{
    label: 'Profile',
    onClick: function onClick() {
      return Link_1.navigate('/my-pages/profile');
    }
  }, {
    label: 'Orders',
    onClick: function onClick() {
      return Link_1.navigate('/my-pages/orders');
    }
  }, {
    label: 'Carts',
    onClick: function onClick() {
      return Link_1.navigate('/my-pages/carts');
    }
  }, {
    label: t('action.signOut'),
    onClick: handleSignOut
  }];
  return user && user.username ? react_1.default.createElement(react_web_components_1.DropdownMenu, {
    align: "right",
    items: items
  }, size.width && size.width > theme.thresholds.sm ? react_1.default.createElement(User, null, react_1.default.createElement("div", null, user.firstName, " ", user.lastName), react_1.default.createElement("small", null, user.username)) : react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, {
    icon: free_solid_svg_icons_1.faUser
  })) : null;
};

var templateObject_1;